import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/shared/shared.module';
import { DEMO } from 'src/app/config/brand.config';

@Component({
  selector: 'app-about',
  imports: [SharedModule, TranslateModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  readonly demo = DEMO;
}
